import toastr from 'toastr';
import { $t } from '@client/i18n/t';

if (typeof toastr !== 'undefined') {
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-top-right',
    preventDuplicates: true,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
  };
}

/**
 * toastr options that will make the toast window continue displaying on screen
 * until the User clicks an X to dismiss it. This can make it easier for Users
 * to see important error messages or copy/paste error text for support.
 */
const stickyOptions = {
  // Keep message on screen instead of disappearing
  timeOut: 0,
  extendedTimeOut: 0,
  // Require clicking X to close it
  tapToDismiss: false,
  closeButton: true,
};

/**
 * Display a temporary notification that disappears after a short time.
 */
function createToastNotification({
  message,
  title,
  type,
  sticky,
}: {
  message: string;
  title?: string;
  type: 'error' | 'success' | 'warning';
  sticky: boolean;
}): any {
  const options = sticky ? stickyOptions : {};

  return toastr[type](message, title, options);
}

/**
 * Display a temporary Error notification that disappears after a short time.
 */
export function createErrorToastNotification(options?: { message?: string; title?: string; sticky?: boolean }): any {
  return createToastNotification({
    type: 'error',
    title: options?.title ?? $t('toast.error.title'),
    message: options?.message ?? $t('toast.error.message'),
    sticky: options?.sticky ?? false,
  });
}

/**
 * Display a temporary Success notification that disappears after a short time.
 */
export function createSuccessToastNotification(options: { message: string; title?: string; sticky?: boolean }): any {
  return createToastNotification({
    type: 'success',
    title: options?.title ?? $t('toast.success.title'),
    message: options.message,
    sticky: options.sticky ?? false,
  });
}

/**
 * Display a temporary Warning notification that disappears after a short time.
 */
export function createWarningToastNotification(options: { message: string; title?: string; sticky?: boolean }): any {
  return createToastNotification({
    type: 'warning',
    title: options?.title ?? $t('toast.warning.title'),
    message: options.message,
    sticky: options.sticky ?? false,
  });
}
